<template>
  <div>
    <div class="y-cust-search-ctr" v-if="showSearch">
      <el-autocomplete
        prefix-icon="el-icon-search"
        v-model="queryString"
        select-when-unmatched
        :fetch-suggestions="querySearch"
        @change="searchLocaleString(queryString)"
        @keyup.native="resetForm(queryString)"
        @select="searchLocaleString(queryString)"
        @clear="clearSearch"
        :trigger-on-focus="false"
        placeholder="Search"
        type="text"
        class="custom-icon cust-search-input"
        clearable
      ></el-autocomplete>
    </div>
    <div>
      <div v-if="showSearchField" class="y-search-form-ctr">
        <cust-conditional-render :dataProps="searchFormField" />
      </div>
      <div class="y-cust-form-ctr" v-else>
        <el-collapse accordion class="y-cust-accordion-ctr">
          <div v-for="item in loadedStrings" :key="item.title">
            <el-collapse-item
              :label="item.title"
              :title="item.title"
              :name="item.title"
              v-if="item.accordion !== false"
              :autoid="item.autoid"
              @click.native="
              showHighlight(item.highlight_class),
                switchPreviewPage(item.previewPageName)
            "
            >
              <div class="y-form-row" v-for="(component, index) in item.form" :key="index">
                <cust-conditional-render :dataProps="component" />
              </div>
              <el-collapse accordion class="y-inner-accordion-ctr" v-if="item.innerAccordion">
                <div v-for="item1 in item.innerAccordion" :key="item1.title">
                  <el-collapse-item
                    :label="item1.title"
                    :title="item1.title"
                    :name="item1.title"
                    :autoid="item1.autoid"
                    @click.native="showHighlight(item1.highlight_class)"
                  >
                    <div class="y-form-row" v-for="(component, index) in item1.form" :key="index">
                      <cust-conditional-render :dataProps="component" />
                    </div>
                  </el-collapse-item>
                </div>
              </el-collapse>
            </el-collapse-item>
          </div>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import CustConditionalRender from '../../components/custConditionalRender.vue'
import { mapActions } from 'vuex'
import { custToolHelper } from '../../mixins/custToolHelper'
export default {
  components: {
    'cust-conditional-render': CustConditionalRender
  },
  $_veeValidate: {
    validator: 'new'
  },
  provide() {
    return {
      $validator: this.$validator
    }
  },
  props: {},
  mixins: [custToolHelper],
  data() {
    return {
      queryString: '',
      compStoreName: 'localeStore',
      showSearch: false
    }
  },
  created() {
    this.$store.state.localeStore.showSearchField = false
  },
  watch: {
    loadedStrings: {
      deep: true,
      handler: 'updateDataSavedStatus'
    }
  },
  computed: {
    loadedStrings() {
      return this.$store.state.localeStore.loadedStrings
    },
    showSearchField() {
      return this.$store.state.localeStore.showSearchField
    },
    searchFormField() {
      return this.$store.state.localeStore.searchFormField
    }
  },
  methods: {
    ...mapActions(['searchLocaleString']),
    validateTextData() {
      console.log('Inside validate method Text--->')
      return this.$validator.validateAll()
    },
    getSearchData() {
      return this.$store.state.localeStore.loadedStrings
    },
    resetForm(queryString) {
      if (queryString == '') {
        this.$store.state.localeStore.showSearchField = false
      }
    }
  }
}
</script>

<style></style>
